export const SliderAlign = {
    RIGHT: "right",
    LEFT: "left"
}